export default {
    values: [
      {value:"bill",               text:{en:"Bill",       cn:"对公转账",  }},  
      {value:"wechat",             text:{en:"WePay",      cn:"微信支付",  }},  
    ],
  };
  